import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { useShipFromContext } from '../../contexts/ship-from-context';
import { ShipFromAddress } from '../ship-from-address';

import { OriginAsReturnAddressCheckbox } from './origin-as-return-address-checkbox/';
import { messages } from '../messages';
import style from '../style.module.less';

export const ReturnAddress = () => {
  const { shipFrom, updateShipFrom, validationErrors, returnAddressSameAsShipFrom, showValidation } = useShipFromContext();

  const onChange = useCallback(
    (address) => {
      updateShipFrom({
        returnAddress: address,
      });
    },
    [updateShipFrom],
  );

  return (
    <div>
      <h4 className={style['address-header']}>
        <FormattedMessage {...messages.returnAddressHeader} />
      </h4>
      <OriginAsReturnAddressCheckbox />
      {!returnAddressSameAsShipFrom && (
        <ShipFromAddress
          address={shipFrom.returnAddress}
          errors={validationErrors?.returnAddress}
          onChange={onChange}
          showValidation={showValidation}
        />
      )}
    </div>
  );
};
